import React from "react";
import {
  PieChart,
  Pie,
  ResponsiveContainer,
  Legend,
  Cell,
  Tooltip,
} from "recharts";

const Polarpie = (props) => {
  const growth = props.reportData ? props.reportData.growth : {};

  const data = [
    { name: "NORMAL", value: parseFloat(growth?.normal || "0") },
    { name: "UNDERWEIGHT", value: parseFloat(growth?.underweight || "0") },
    { name: "OVERWEIGHT", value: parseFloat(growth?.overweight || "0") },
    { name: "OBESE", value: parseFloat(growth?.obese || "0") },
  ];

  const COLORS = ["#5BB8FF", "#24CCB8", "#FFBB28", "#FB545E"];

  // Custom label function to show percentage inside slices
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
    const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));

    return (
      <text
        x={x}
        y={y}
        fill="white"
        fontSize="12px"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="Montserrat"
        fontWeight={500}
      >
        {`${(percent * 100).toFixed(1)}%`}
      </text>
    );
  };

  // Custom Tooltip Component
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const total = data.reduce((sum, entry) => sum + entry.value, 0); // Calculate total for percentage
      const percentage = ((payload[0].value / total) * 100).toFixed(1); // Calculate percentage

      return (
        <div
          style={{
            background: "white",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
        >
          <p
            style={{
              color: payload[0]?.payload?.fill,
              fontWeight: 500,
              margin: 0,
              fontSize: 12,
            }}
          >
            {payload[0].name}
          </p>
          <p
            style={{
              margin: 0,
              fontSize: 12,
              fontFamily: "Montserrat",
              fontWeight: 500,
            }}
          >{`${percentage}%`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer
      minHeight={300}
      style={{ display: "flex", alignItems: "center" }}
    >
      <PieChart>
        <Pie
          isAnimationActive={true}
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius={"90%"}
          dataKey="value"
          stroke=""
          fontFamily="Montserrat"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          content={<CustomTooltip />}
          style={{ fontFamily: "Montserrat" }}
        />
        <Legend
          fontFamily="Montserrat"
          fontSize={10}
          layout="vertical"
          align="right"
          verticalAlign="middle"
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default Polarpie;
